export default "__VITE_ASSET__Cro8u8es__"